<template>
	<fieldset class="fieldset">
		<div class="form-row two-columns">
			<field-box name="property_land[street]" :label="$t('forms.street')" type="text" :value="data?.street" :disabled="disabled" :has-error="errors?.['property_lane.street']?.length"/>
			<field-box name="property_land[street_number]" :label="$t('forms.street_number')" type="text" :value="data?.street_number" :disabled="disabled" :has-error="errors?.['property_lane.street_number']?.length"/>
		</div>
		<div class="form-row two-columns">
			<field-box name="property_land[city]" :label="$t('forms.city')" type="text" :value="data?.city" :disabled="disabled" :has-error="errors?.['property_lane.city']?.length"/>
			<field-box name="property_land[zip]" :label="$t('forms.zip')" type="text" :value="data?.zip" :disabled="disabled" :has-error="errors?.['property_lane.zip']?.length"/>
		</div>
		<div class="form-row">
			<field-box name="property_land[area]" :label="$t('forms.area')" type="number" :value="data?.area" :disabled="disabled" :has-error="errors?.['property_lane.area']?.length"/>
		</div>
	</fieldset>
</template>

<script>

import DefaultFieldBox from "@/components/form-fields/DefaultFieldBox.vue";
import FieldBox from "@/components/form-fields/FieldBox.vue";

export default {
	name: "PropertyLandFieldset",
	props: ['data', 'disabled', 'errors'],
	components: {
		DefaultFieldBox,
		FieldBox
	},
	computed: {

	}
}
</script>

<style scoped lang="scss">
fieldset {
	margin: 0;
	padding: 0;
	margin-inline: 0;
	padding-block: 0;
	padding-inline: 0;
	border: none;
}


.form-row {
	margin-bottom: 15px;

	&:last-child {
		margin-bottom: 0;
	}

	&.two-columns {
		display: flex;
		justify-content: space-between;
		flex-direction: row;

		.field-box {
			width: calc(50% - 8px);
		}
	}
}

@media($mobileS) {
	.form-row {
		margin-bottom: 10px;

		&.two-columns {
			flex-direction: column;

			.field-box {
				width: 100%;
				margin-bottom: 10px;

				&:last-child {
					margin-bottom: 0;
				}
			}
		}
	}
}

</style>